import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { useEffect, useRef } from 'react';

import Message from '../Message/Message';

import styles from './MessagesList.module.css';

import confetti from '../../assets/video/confetti.webm';
import { useGetParams } from '../../hooks/useGetParams';

export const MessagesList = ({ messages, winId, speed, isWinnerStage }) => {
  const { authorFontSize } = useGetParams();

  const confettiRef = useRef(null);

  useEffect(() => {
    let idTimeout = '';
    if (confettiRef.current && isWinnerStage) {
      idTimeout = setTimeout(() => {
        confettiRef.current.play().catch((error) => {});
      }, 1500);
    } else if (idTimeout) {
      clearTimeout(idTimeout);
    }
    return () => {
      clearTimeout(idTimeout);
    };
  }, [isWinnerStage]);

  return (
    <div className={styles.wrapper}>
      <div className={styles.messagesWrapper}>
        <TransitionGroup className={styles.messages} appear={true}>
          {messages.length > 0 &&
            messages.map((item, i) => (
              <CSSTransition
                key={item.UUID}
                timeout={speed}
                classNames={{
                  appearActive: styles['position-appear-active'],
                  enterActive: styles['position-enter-active'],
                  exit: styles['position-exit'],
                  exitActive: styles['position-exit-active'],
                }}
              >
                <Message
                  winId={winId}
                  key={item.id}
                  message={item.message}
                  authorFontSize={authorFontSize}
                  isWinnerStage={isWinnerStage}
                />
              </CSSTransition>
            ))}
        </TransitionGroup>
      </div>

      {isWinnerStage && (
        <video
          ref={confettiRef}
          muted="muted"
          loop
          playsInline
          className={styles.confetti}
        >
          <source src={confetti} type="video/webm"></source>
        </video>
      )}
    </div>
  );
};
